import { Module } from 'vuex'
import { activeNone, clearCurrentTopology, collapseOpenDefault, noneTopology } from '../editor/constants'
import { RootState } from '../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import State from './types'

import _ from 'lodash'
import { activeDivisionNone } from '../editor-divisions/constants'
import { activeDocumentFolderNone } from '../editor-documents/constants'
import { activeImageFolderNone } from '../editor-images/constants'
import { blankModels } from '../editor-model/constants'
import { activeScheduleNone } from '../editor-schedules/constants'
import { activeUserNone } from '../editor-security/constants'
import { activeSiteNone } from '../editor-site/constants'
import { loadingUser } from '../security/constants'

export const state: State = {
  error: false,
  activeItem: activeNone,
  activeTopology: _.assign({}, clearCurrentTopology),
  categoryOpen: {},
  productClassOpen: {},
  manufacturingSeriesOpen: {},
  productOpen: {},
  collapseOpen: collapseOpenDefault,
  hideNotVisible: false,
  showNameInTree: false,
  activeSite: activeSiteNone,
  activeUser: activeUserNone,
  activeImageFolder: activeImageFolderNone,
  activeDocumentFolder: activeDocumentFolderNone,
  activeSchedule: activeScheduleNone,
  activeDivision: activeDivisionNone,
  subRoutes: {},
  fullScreen: false,
  recentlySearchedPcns: [],
  modelSearchResults: blankModels,
  customers: [],
  currentUser: loadingUser,
  customerShipTos: [],
  isShowingProductModels: false,
  originalItem: noneTopology,
  treeCategories: [],
  currentTopology: _.assign({}, clearCurrentTopology),
  treeLoading: false,
  preloaded: false,
  isProductSectionsLoading: false,
}

const namespaced = true

export const orderState: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
